import type taxEn from "./tax.en";

const taxAr: Record<keyof typeof taxEn, string> = {
  "settings.taxes": "الضرائب والرسوم",
  "settings.taxes_hint": "نسب ضريبة القيمة المضافة والتسجيلات وطريقة الحساب",
  "tax.advisor": "النسب الافتراضية للتسهيل فقط. أكّدها مع مستشارك الضريبي قبل بدء البيع.",
  "tax.countries": "أين تحصّل الضريبة",
  "tax.countries_hint": "فعّل التحصيل لكل دولة أنت مسجّل فيها لضريبة القيمة المضافة. يُحتسب على العملاء الذين يشحنون إليها النسبة الظاهرة.",
  "tax.add_country": "إضافة دولة",
  "tax.add_country_hint": "ستحصّل الضريبة على الطلبات المشحونة إلى هذه الدولة. أضف رقم التسجيل بعد ذلك.",
  "tax.country_added": "بدأ تحصيل الضريبة في {country}.",
  "tax.collect": "تحصيل",
  "tax.stop": "إيقاف التحصيل",
  "tax.collecting": "يتم التحصيل",
  "tax.not_collecting": "لا يتم التحصيل",
  "tax.no_rate": "لا توجد نسبة افتراضية — حدّد واحدة",
  "tax.custom_rate": "نسبة مخصصة",
  "tax.add_number": "أضف رقم التسجيل",
  "tax.n_overrides": "{n} استثناءات",
  "tax.collect_in": "تحصيل الضريبة في {country}",
  "tax.number": "رقم التسجيل الضريبي",
  "tax.number_hint": "يظهر على الفواتير، وهو مطلوب لاحتساب ضريبة القيمة المضافة في معظم دول الخليج.",
  "tax.name_on_registration": "الاسم في التسجيل",
  "tax.effective_from": "تاريخ التسجيل",
  "tax.rate": "النسبة",
  "tax.rate_hint_default": "اتركها فارغة لاستخدام النسبة الافتراضية ({rate}٪).",
  "tax.rate_hint_none": "لا توجد نسبة افتراضية لهذه الدولة؛ أدخل النسبة التي تحتسبها.",
  "tax.calculation": "طريقة الحساب",
  "tax.prices_include": "الأسعار تشمل الضريبة",
  "tax.prices_include_hint": "الطريقة المعتادة في الخليج: السعر الذي تدخله هو ما يدفعه العميل شاملًا الضريبة.",
  "tax.shipping": "احتساب الضريبة على الشحن",
  "tax.shipping_hint": "تُطبّق ضريبة القيمة المضافة على رسوم التوصيل في الإمارات والسعودية والبحرين وعُمان.",
  "tax.rounding": "التقريب",
  "tax.rounding.per_line": "تقريب كل بند (افتراضي)",
  "tax.rounding.per_invoice": "تقريب مرة واحدة لكل فاتورة",
  "tax.display": "أسعار المتجر",
  "tax.display.inclusive": "عرض الأسعار شاملة الضريبة",
  "tax.display.exclusive": "عرض الأسعار قبل الضريبة",
  "tax.overrides": "الاستثناءات",
  "tax.overrides_hint": "احتسب نسبة مختلفة لبعض المنتجات أو المجموعات أو الشحن، مثل السلع الخاضعة لنسبة صفر.",
  "tax.add_override": "إضافة استثناء",
  "tax.no_overrides": "لا توجد استثناءات. كل المنتجات تستخدم نسبة دولتها.",
  "tax.delete_override": "حذف هذا الاستثناء؟",
  "tax.applies_to": "ينطبق على",
  "tax.scope.product": "منتج",
  "tax.scope.collection": "مجموعة",
  "tax.scope.shipping": "الشحن",
  "tax.scope.country": "منطقة في دولة",
  "tax.scope.region": "المنطقة {region}",
  "tax.search_products": "ابحث عن منتجات",
  "tax.search_collections": "ابحث عن مجموعات",
  "tax.no_matches": "لا توجد نتائج.",
  "tax.change": "تغيير",
  "tax.region": "رمز المنطقة",
  "tax.region_required": "مطلوب للنسب الإقليمية.",
  "tax.tax_name": "اسم الضريبة",
  "tax.calculator": "حاسبة الضريبة",
  "tax.calculator_hint": "تحقق مما سيدفعه العميل بإعداداتك الحالية.",
  "tax.ship_to": "الشحن إلى",
  "tax.shipping_amount": "الشحن",
  "tax.order_discount": "خصم الطلب",
  "tax.customer_exempt": "عميل معفى من الضريبة",
  "tax.calculate": "احسب",
  "tax.not_collecting_banner": "أنت لا تحصّل الضريبة في {country}، لذلك لا تُحتسب ضريبة.",
  "tax.col.item": "البند",
  "tax.col.net": "المبلغ",
  "tax.col.rate": "الضريبة",
  "tax.col.tax": "قيمة الضريبة",
  "tax.discount_of": "خصم {amount}",
  "tax.subtotal": "المجموع الفرعي",
  "tax.included": "مشمولة",
  "tax.total": "الإجمالي",
  "tax.why.not_collecting": "لا يتم التحصيل هنا",
  "tax.why.not_taxable": "غير خاضع للضريبة",
  "tax.why.exempt": "معفى",
  "tax.why.customer_exempt": "العميل معفى",
  "tax.why.shipping_not_taxed": "الشحن غير خاضع للضريبة",
};

export default taxAr;
